import { PricingRegionEnum, getCountriesByRegion } from '@final-commerce/common';

export type PricingRegion = PricingRegionEnum;

export const PRICING_REGION_ORDER: PricingRegionEnum[] = [
  PricingRegionEnum.NORTH_AMERICA,
  PricingRegionEnum.EUROPE,
  PricingRegionEnum.OTHER,
];

export const PRICING_REGION_LABELS: Record<PricingRegionEnum, string> = {
  [PricingRegionEnum.NORTH_AMERICA]: 'North America',
  [PricingRegionEnum.EUROPE]: 'Europe',
  [PricingRegionEnum.OTHER]: 'Other',
};

export const SUPPORTED_PRICING_COUNTRIES: string[] = PRICING_REGION_ORDER.flatMap((region) => [
  ...getCountriesByRegion(region),
]);

export const COUNTRY_LABELS: Record<string, string> = {
  US: 'United States',
  CA: 'Canada',
  MX: 'Mexico',
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  CH: 'Switzerland',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DE: 'Germany',
  DK: 'Denmark',
  EE: 'Estonia',
  ES: 'Spain',
  FI: 'Finland',
  FR: 'France',
  GB: 'United Kingdom',
  GI: 'Gibraltar',
  GR: 'Greece',
  HR: 'Croatia',
  HU: 'Hungary',
  IE: 'Ireland',
  IT: 'Italy',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  MT: 'Malta',
  NL: 'Netherlands',
  NO: 'Norway',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SE: 'Sweden',
  SI: 'Slovenia',
  SK: 'Slovakia',
  AE: 'United Arab Emirates',
  AU: 'Australia',
  BR: 'Brazil',
  HK: 'Hong Kong',
  IN: 'India',
  JP: 'Japan',
  MY: 'Malaysia',
  NZ: 'New Zealand',
  SG: 'Singapore',
  TH: 'Thailand',
};
